<template>
  <div class="home">
 <v-carousel hide-delimiters>
    <v-carousel-item
      v-for="(item,i) in items"
      :key="i"
      :src="item.src"
    >
      <v-jumbotron dark>
            <v-container fill-height>
              <v-layout style="margin-top:70px">
                <v-flex>
                  <h3 class="display-3">{{ item.text }}</h3>
                  <h3 class="display-3">{{ item.text1 }}</h3>
                  <h3 class="display-3">{{ item.text2 }}</h3>
                </v-flex>
              </v-layout>
            </v-container>
          </v-jumbotron>
         </v-carousel-item>
  </v-carousel>

<v-container grid-list-md text-lg-center>
<div class="cards"> 
    <v-layout  justify-center>
    <v-flex lg3>
      <v-card>
        <v-img
          src="/assets/img_home/3.jpg"
          aspect-ratio="1.75"
        ></v-img>

        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Выполнение работ в сроки</h3>
          
          </div>
        </v-card-title>
      </v-card>
    </v-flex>

     <v-flex lg3>
      <v-card>
        <v-img
          src="/assets/img_home/2.jpg"
          aspect-ratio="1.75"
        ></v-img>

        <v-card-title primary-title>
          <div >
            <h3 class="headline mb-0" >Гарантия 100% Качества </h3>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>

     <v-flex lg3>
      <v-card>
        <v-img
          src= "/assets/img_home/1.jpg"
          aspect-ratio="1.75"
        ></v-img>

        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Ручная гравировка портретов</h3>
            <!-- <div> {{ card_text }} </div> -->
          </div>
        </v-card-title>
      </v-card>
    </v-flex>


    <v-flex lg3>
      <v-card>
        <v-img
          src= "/assets/img_home/4.jpg"
          aspect-ratio="1.75"
        ></v-img>

        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Скидки со второго заказа</h3>
            <!-- <div> {{ card_text }} </div> -->
          </div>
        </v-card-title>
      </v-card>
    </v-flex>

    
  </v-layout>

</div>

</v-container>

  <v-footer class="pa-3">
    <v-spacer></v-spacer>
    <div>&copy; {{ new Date().getFullYear() }}</div>
  </v-footer>
  </div>
</template>

<script>


export default {
    data () {
      return {
        items: [
          {
            src: '/assets/img_slider/1.jpg',
            text:  "Изготовление",
            text1: "Памятников",
            text2: "в Киржаче"
          },
          {
            src: '/assets/img_slider/2.jpg',
             text:  "Памятник на могилу",
            text1: "Из карельского гранита",
            text2: "С декоративным оформлением"
          },
          {
            src: '/assets/img_slider/3.jpg',
              text:  "Мемориальные комплексы",
            text1: "И ограды",
          }
         
        ],
        card_text: "privet",
      

        
      }
    }
  }
</script>
<style scoped>
.home{
  margin-top: 65px;
}
.cards{
  margin-top: 30px;
}
.display-3{
 display: flex;
 justify-content: flex-start;
 font-style:italic;
}
</style>
